document.querySelectorAll('.menu-characteristics-filter').forEach((form) => {
  const select = form.querySelector('[name="dietary-restrictions"');
  
  select.addEventListener('change', (event) => {
    const value = select.value;
    window.menu_characteristics = value;
    const venue = get_current_venue_info();
    
    const venueEvent = new CustomEvent('venueChanged', { detail: { venue: venue.id } });
    document.body.dispatchEvent(venueEvent);
  });
});

const updateCharacteristicsFilterSelects = () => {
  const value = window.menu_characteristics ?? '';

  document.querySelectorAll('.menu-characteristics-filter').forEach((form) => {
    const select = form.querySelector('[name="dietary-restrictions"');
    select.value = value;
  });
}
document.body.addEventListener('venueChanged', updateCharacteristicsFilterSelects);
